module.exports = __webpack_public_path__ + "static/img/auth-success.6d1d521d.png";